import { render, staticRenderFns } from "./UpdateRequest.vue?vue&type=template&id=7c6ff3db&scoped=true&"
import script from "./UpdateRequest.vue?vue&type=script&lang=ts&"
export * from "./UpdateRequest.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateRequest.vue?vue&type=style&index=0&id=7c6ff3db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6ff3db",
  null
  
)

export default component.exports